/**
 * Basic Info Section for Recipe Import Preview
 *
 * Displays title and description fields for editing extracted recipe data.
 */

import type { ExtractedRecipe } from '@/types/recipeImport';

interface BasicInfoSectionProps {
  recipe: ExtractedRecipe;
  onChange: (recipe: ExtractedRecipe) => void;
}

export function BasicInfoSection({ recipe, onChange }: BasicInfoSectionProps) {
  return (
    <div className="grid grid-cols-2 gap-4">
      {/* Title */}
      <div className="col-span-2 flex flex-col gap-1.5">
        <label htmlFor="recipe-title" className="text-sm font-medium text-gray-700">
          Recipe Title
        </label>
        <input
          id="recipe-title"
          type="text"
          value={recipe.title}
          onChange={(e) => onChange({ ...recipe, title: e.target.value })}
          placeholder="e.g., Spaghetti Carbonara"
          className="px-3.5 py-2.5 border border-gray-200 rounded-lg text-sm focus:outline-none focus:border-blue-600 focus:ring-1 focus:ring-blue-600"
          required
        />
      </div>

      {/* Description */}
      <div className="col-span-2 flex flex-col gap-1.5">
        <label htmlFor="recipe-description" className="text-sm font-medium text-gray-700">
          Description <span className="font-normal text-gray-400">(optional)</span>
        </label>
        <textarea
          id="recipe-description"
          value={recipe.description || ''}
          onChange={(e) => onChange({ ...recipe, description: e.target.value || null })}
          placeholder="A brief description of the dish..."
          rows={3}
          className="px-3.5 py-2.5 border border-gray-200 rounded-lg text-sm resize-y min-h-[100px] focus:outline-none focus:border-blue-600 focus:ring-1 focus:ring-blue-600"
        />
      </div>
    </div>
  );
}
